<div class="categories">

  <div class="categories-aside" *ngIf="(categories$ | async) as categories">
    <div class="categories-parentCategory" *ngFor="let category of categories; let i = index">
      <div class="categories-parentCategoryItem"
        [ngClass]="{'categories-parentCategoryItem_active': i === parentCatIndex}" (click)="setParentCatIndex(i)">
        <i *ngIf="category.icon" svgImage [image]="'loose-categories/' + category.icon"></i>
        {{ ('LOOSE_ARTICLE_CATEGORIES.' + category.id)| translate}}
      </div>
    </div>
  </div>

  <div class="categories-content" *ngIf="(categories$ | async) as categories">
    <ng-container *ngIf="categories[parentCatIndex] && categories[parentCatIndex].categories">
      <ng-container *ngFor="let mainCategory of categories[parentCatIndex].categories">
        <ng-container *ngFor="let category of mainCategory.subcategories; let i = index;">
          <div class="categories-categoryWrapper"
            [ngClass]="{'_first': i === 0, '_last': i === mainCategory.subcategories.length-1}">
            <div class="categories-categoryLabel" *ngIf="i === 0 && mainCategory.subcategories.length === 0"
              (click)="onSelect(mainCategory.id)">
              {{ ('LOOSE_ARTICLE_CATEGORIES.' + mainCategory.id)| translate}}
            </div>
            <div class="categories-categoryText" *ngIf="i === 0 && mainCategory.subcategories.length > 0">
              {{ ('LOOSE_ARTICLE_CATEGORIES.' + mainCategory.id)| translate}}
            </div>
            <div class="categories-categoryItem">
              <div class="categories-categoryInner">
                <div *ngIf="!category.subcategories || category.subcategories.length === 0"
                  class="categories-categoryContent categories-categoryContentClick" (click)="onSelect(category.id)">
                  <i *ngIf="category.icon" class="categories-categoryIcon" svgImage
                    [image]="'loose-categories/' + category.icon"></i>
                  {{ ('LOOSE_ARTICLE_CATEGORIES.' + category.id)| translate}}
                  <i class="arrow" svgIcon [icon]="'arrow'"></i>
                </div>
                <div *ngIf="category.subcategories && category.subcategories.length > 0"
                  class="categories-categoryContent">
                  <i *ngIf="category.icon" class="categories-categoryIcon" svgImage
                    [image]="'loose-categories/' + category.icon"></i>
                  {{ ('LOOSE_ARTICLE_CATEGORIES.' + category.id)| translate}}
                </div>
                <div class="categories-subCategoryList" *ngIf="category.subcategories">
                  <div class="categories-subCategoryItem" *ngFor="let subcategory of category.subcategories"
                    (click)="onSelect(subcategory.id)">
                    {{ ('LOOSE_ARTICLE_CATEGORIES.' + subcategory.id)| translate}}
                    <i class="arrow" svgIcon [icon]="'arrow'"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
